import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { Location } from '@angular/common';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../services/role.service';
import { UserDto } from '../../dto/user.dto';
import { BaseService } from '../../base.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  user: any = {
    id: null,
    email: '',
    name: '',
    lastName: '',
    phone: '',
    dni: '',
    creationDate: null,
    status: null,
    creationUser: null,
    role: '',
    fullName: '',
    password: ''
  };
  button_status: boolean;
  title_component: string;
  listRole = [];
  email_status: boolean;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private userService: UserService,
    private roleService: RoleService,
    private toastr: ToastrService,
    private router: Router,
    private baseService: BaseService
  ) { }

  ngOnInit() {

    this.title_component = 'Crear Usuario';
    this.baseService.changedComponentName(this.title_component);

    this.button_status = true;
    this.getRoles();
    this.email_status = false;
  }

  getRoles(): void {
    this.roleService.getAll()
      .subscribe(data => {
        this.listRole.push({ value: '', desc: '-- SELECCIONE ROL --' });
        data.forEach((rol) => {
          this.listRole.push({ value: rol.id, desc: rol.name });
        });
      });
  }

  goBack(event): void {
    this.location.back();
  }

  create(value): void {
    const message = 'Usuario creado con exito.';
    const id_role = value.role;
    const idrole = +id_role;
    const dto = new UserDto(idrole, value.email, value.password, value.name, value.lastName, value.phone, value.dni);

    this.userService.createUser(dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.baseService.showSuccess(message);
          this.router.navigate(['/dashboard/users']);
        }, 1000);
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('Ocurrió un error:', err.error.message);
      } else {
        console.log('Backend devuelto código de estado: ', err.status);
        console.log('Response body:', err.error);
        if (err.status === 409) {
          setTimeout(() => {
            this.baseService.showError(err.error.message);
            this.email_status = true;
          }, 1000);
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/user/create-user.component.ts